import { ClientScoreHealthRangeProps } from '..';
import { ClientScoreHealthRange } from '../ScoreHealthRange';
import { SAVINGS_RATE_SCORE_HEALTH_RANGE_BREAKPOINTS } from './constants';
import { SAVINGS_RATE_SCORECARD_ELEMENT_SYMBOL } from '../../../Scorecard';

export function ClientSavingsRateScoreHealthRange(props: Omit<ClientScoreHealthRangeProps, 'breakpoints' | 'element'>) {
  return (
    <ClientScoreHealthRange
      {...props}
      element={SAVINGS_RATE_SCORECARD_ELEMENT_SYMBOL}
      breakpoints={SAVINGS_RATE_SCORE_HEALTH_RANGE_BREAKPOINTS}
    />
  );
}
